import { memo } from 'react'

interface LoadingSpinnerIconProps {
  size?: number
}

const LoadingSpinnerIcon: React.FC<LoadingSpinnerIconProps> = memo(
  ({ size = 32 }) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" width="32" height="32" rx="16" fill="#78788C" />
      <path
        d="M16.5 24C15.4067 24 14.3733 23.79 13.4 23.37C12.4267 22.95 11.5767 22.3767 10.85 21.65C10.1233 20.9233 9.55 20.0733 9.13 19.1C8.71 18.1267 8.5 17.0933 8.5 16C8.5 14.8933 8.71 13.8567 9.13 12.89C9.55 11.9233 10.1233 11.0767 10.85 10.35C11.5767 9.62333 12.4267 9.05 13.4 8.63C14.3733 8.21 15.4067 8 16.5 8C16.7267 8 16.9167 8.07667 17.07 8.23C17.2233 8.38333 17.3 8.57333 17.3 8.8C17.3 9.02667 17.2233 9.21667 17.07 9.37C16.9167 9.52333 16.7267 9.6 16.5 9.6C14.7267 9.6 13.2167 10.2233 11.97 11.47C10.7233 12.7167 10.1 14.2267 10.1 16C10.1 17.7733 10.7233 19.2833 11.97 20.53C13.2167 21.7767 14.7267 22.4 16.5 22.4C18.2733 22.4 19.7833 21.7767 21.03 20.53C22.2767 19.2833 22.9 17.7733 22.9 16C22.9 15.7733 22.9767 15.5833 23.13 15.43C23.2833 15.2767 23.4733 15.2 23.7 15.2C23.9267 15.2 24.1167 15.2767 24.27 15.43C24.4233 15.5833 24.5 15.7733 24.5 16C24.5 17.0933 24.29 18.1267 23.87 19.1C23.45 20.0733 22.8767 20.9233 22.15 21.65C21.4233 22.3767 20.5767 22.95 19.61 23.37C18.6433 23.79 17.6067 24 16.5 24Z"
        fill="#F5F5F5"
      />
    </svg>
  ),
)

export { LoadingSpinnerIcon }
